module.exports = __webpack_public_path__ + "img/mm.b1704e1d.png";